@if (true) {
<div class="modal-body">
  <form
    #AddCommunity="ngForm"
    [formGroup]="AddCommunityEvent"
    (ngSubmit)="onCommunitySubmit(AddCommunity.value)">

    <div class="card rounded-4 border-0">
      <div class="card-body">

        <!-- ================= BASIC DETAILS ================= -->
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="form-label">Community Name</label>
              <input
                class="form-control"
                formControlName="CommunityName"
                placeholder="Enter Community Name"
                type="text">
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="form-label">Community Code</label>
              <div class="fw-semibold">
                {{ CommunityCode || '--' }}
              </div>
            </div>
          </div>
        </div>

        <!-- ================= LICENSE STATUS ================= -->
        <div class="card table-container mt-4">
          <table class="custom-table">
            <thead>
              <tr>
                <th>License Status</th>
                <th>Allocated</th>
                <th>Consumed</th>
              </tr>
            </thead>

            <tbody>
              <app-table-state
                [loading]="loading"
                [error]="null"
                [empty]="!licenseData"
                [rows]="6"
                [columns]="3">
              </app-table-state>

              @if (licenseData) {

                <tr>
                  <td>No. Of Paid Users</td>
                  <td>{{ licenseData.AllocateUser ?? '--' }}</td>
                  <td
                    [class.text-danger]="licenseData.ConsumedPaidUser > licenseData.AllocateUser">
                    {{ licenseData.ConsumedPaidUser ?? '--' }}
                  </td>
                </tr>

                <tr>
                  <td>No. Of Un-Paid Users</td>
                  <td>{{ licenseData.AllocateUnPaidUser ?? '--' }}</td>
                  <td
                    [class.text-danger]="licenseData.ConsumedUser > licenseData.AllocateUnPaidUser">
                    {{ licenseData.ConsumedUser ?? '--' }}
                  </td>
                </tr>

                <tr>
                  <td>No. Of Company</td>
                  <td>{{ licenseData.AllocateCompany ?? '--' }}</td>
                  <td
                    [class.text-danger]="licenseData.ConsumedCompany > licenseData.AllocateCompany">
                    {{ licenseData.ConsumedCompany ?? '--' }}
                  </td>
                </tr>

                <tr>
                  <td>Disk Space (MB)</td>
                  <td>{{ licenseData.AllocateDisk ?? '--' }}</td>
                  <td
                    [class.text-danger]="licenseData.ConsumedDisk > licenseData.AllocateDisk">
                    {{ licenseData.ConsumedDisk ?? '--' }}
                  </td>
                </tr>

                <tr>
                  <td>No. Of Email</td>
                  <td>{{ licenseData.AllocateEmail ?? '--' }}</td>
                  <td
                    [class.text-danger]="licenseData.ConsumedEmail > licenseData.AllocateEmail">
                    {{ licenseData.ConsumedEmail ?? '--' }}
                  </td>
                </tr>

                <tr>
                  <td>No. Of SMS</td>
                  <td>{{ licenseData.AllocateSMS ?? '--' }}</td>
                  <td
                    [class.text-danger]="licenseData.ConsumedSMS > licenseData.AllocateSMS">
                    {{ licenseData.ConsumedSMS ?? '--' }}
                  </td>
                </tr>

              }
            </tbody>
          </table>
        </div>

        <!-- ================= PAYMENT STATUS ================= -->
        <div class="row mt-4">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label class="form-label">Payment Status</label>
              <div
                class="fw-semibold"
                [class.text-danger]="PaymentStatus !== 'Paid'"
                [class.text-success]="PaymentStatus === 'Paid'">
                {{ PaymentStatus || '--' }}
              </div>
            </div>
          </div>
        </div>

        <!-- ================= LOGO UPLOAD ================= -->
        <div class="row mt-3 align-items-center">
          <div class="col-12 col-md-4">
            <div class="form-group">
              <label class="form-label">Logo *</label>
              <input
                type="file"
                formControlName="browseFiles"
                accept="image/x-png,image/gif,image/jpeg"
                (change)="onSelectFile($event)">
            </div>
          </div>

          <div class="col-12 col-md-4" *ngIf="Logo">
            <img
              [src]="Logo"
              class="img-fluid border rounded"
              style="max-height: 60px;">
          </div>
        </div>
        <!-- ================= NOTES ================= -->
        <div class="mt-3 text-danger small">
          Note:- Logo should be in JPG or PNG format.  
          Logo height should not exceed 40px.
        </div>

        <!-- ================= SUBMIT ================= -->
        <div class="row mt-4 justify-content-center">
          @if (RightsID.includes('202022001') || RightsID.includes('202022021')) {
            <div class="col-12 col-md-3">
              <button class="btn btn-primary submit-btn small w-100" type="submit">
                Submit
              </button>
            </div>
          }
        </div>


      </div>
    </div>
  </form>
</div>

}@else {
<!-- <div class="modal-body  col-xs-12 form-group">
    <form #AddCommunity="ngForm" [formGroup]="AddCommunityEvent" (ngSubmit)="onCommunitySubmit(AddCommunity.value);">

        <div class="col-xs-12" style="padding:4px">&nbsp;
            <div class="col-xs-4 height-34">Community Name</div>
            <div class="col-xs-5"><input class="form-control" formControlName="CommunityName"
                    placeholder="Enter Community Name" type="text">

            </div>
            <div class="col-xs-3">&nbsp;</div>
        </div>
        <div class="col-xs-12">
            <hr>
        </div>
        <div class="col-xs-12" style="padding:4px">&nbsp;
            <div class="col-xs-4 height-34">Community Code</div>
            <div class="col-xs-5 height-34">{{CommunityCode}} </div>
            <div class="col-xs-3">&nbsp;</div>
        </div>
        <div class="col-xs-12" style="padding:4px">
            <div style=" border:grey solid 1px;" class="col-xs-4"><b>License Status</b></div>
            <div style=" border:grey solid 1px;" class="col-xs-3"><b>Allocated</b></div>
            <div style=" border:grey solid 1px;" class="col-xs-3"><b>Consumed</b></div>
            <div class="col-xs-2"><b>&nbsp;</b></div>
            <div style=" border:grey solid 1px;" class="col-xs-4">No. Of Paid Users</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{AllocateUser}}</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{ConsumedPaidUser}}</div>
            <div class="col-xs-2"><b>&nbsp;</b></div>
            <div style=" border:grey solid 1px;" class="col-xs-4">No. Of Un-Paid Users</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{AllocateUnPaidUser}}</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{ConsumedUser}}</div>
            <div class="col-xs-2"><b>&nbsp;</b></div>
            <div style=" border:grey solid 1px;" class="col-xs-4">No. Of Company</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{AllocateCompany}}</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{ConsumedCompany}}</div>
            <div class="col-xs-2"><b>&nbsp;</b></div>
            <div style=" border:grey solid 1px;" class="col-xs-4">Disk Space [in MB]</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{AllocateDisk}}</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{ConsumedDisk}}</div>
            <div class="col-xs-2"><b>&nbsp;</b></div>
            <div style=" border:grey solid 1px;" class="col-xs-4">No. Of Email</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{AllocateEmail}}</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{ConsumedEmail}}</div>
            <div class="col-xs-2"><b>&nbsp;</b></div>
            <div style=" border:grey solid 1px;" class="col-xs-4">No. Of SMS</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{AllocateSMS}}</div>
            <div style=" border:grey solid 1px;" class="col-xs-3">{{ConsumedSMS}}</div>
            <div class="col-xs-2"><b>&nbsp;</b></div>
        </div>
        <div class="col-xs-12" style="padding:4px">&nbsp;
            <div class="col-xs-4 height-34">Payment Status</div>
            <div class="col-xs-5 height-34" style="color: red;">{{PaymentStatus}} </div>
            <div class="col-xs-3">&nbsp;</div>
        </div>
        <div class="col-xs-12">
            <hr>
        </div>

        <div class="col-xs-12" style="padding:4px">&nbsp;
            <div class="col-xs-4 height-34">Logo*<br> </div>
            <div class="col-xs-4" style="padding-top:5px;"><input type='file' formControlName="browseFiles"
                    accept="image/x-png, image/gif, image/jpeg" (change)="onSelectFile($event)">

            </div>
            <div class="col-xs-4"><img [src]="Logo" width="200px" height="60px"></div>
        </div>


        <div class="col-xs-4">&nbsp;</div>
        <div class="col-xs-5">
            <div class="form-group col-xs-4"
                *ngIf="this.RightsID.includes('202022001') || this.RightsID.includes('202022021') ; then AddCommunityLink else AddCommunityNotLink">
            </div>
            <ng-template #AddCommunityLink>
                <input class="btn btn-primary col-xs-6" type="submit" value="Submit">
            </ng-template>
            <ng-template #AddCommunityNotLink>
                &nbsp;
            </ng-template>
        </div>
        <div class="col-xs-3"><label style="Display:none;" *ngFor='let urldata of fileurls'>{{urldata}}</label></div>
        <div class="col-xs-12">
            <span style="color: red;">Note:- Logo Should be in .JPG or .PNG Format<br>
                Logo Height should not be more than 40px </span>
        </div>
        <div class="form-group mt-2" style="display:none;">
            <div class="form-check">
                <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true
                    [(ngModel)]="options.autoClose">
                <label for="autoClose">Auto close alert after three seconds</label>
            </div>

        </div>
        <div class="jumbotron p-4">
            <div class="container text-center col-sm-4 alertCss">
                <app-alert></app-alert>
                <router-outlet></router-outlet>
            </div>
        </div>
    </form>
</div> -->
}